import { Action } from '../../actions';
import { StoreState } from '../../reducers';
import { Dispatch } from 'react-redux';
import IndexedDBManager from '../../utils/indexedDB/manager';

export enum DownloadAllPopupActionKeys {
	CLOSE = '@@DownloadAllPopup/CLOSE',
}

export type DownloadAllPopupAction = CloseAction;

interface CloseAction extends Action {
	type: DownloadAllPopupActionKeys.CLOSE;
}

export const closeDownloadAllPopup = (dontAskAgain: boolean = false) =>
	(dispatch: Dispatch<StoreState>): void => {

		if (dontAskAgain) {
			IndexedDBManager.setDownloadPopupDontAskAgain().then();
		}
		dispatch({
			type: DownloadAllPopupActionKeys.CLOSE,
		});
	};

export const closeDownloadAllPopupIfNeeded = () => async (dispatch: Dispatch<StoreState>): Promise<void> => {
	const downloadPopupDontAskAgain = await IndexedDBManager.getDownloadPopupDontAskAgain();

	if (downloadPopupDontAskAgain) {
		dispatch(closeDownloadAllPopup());
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DownloadAllPopup/actions.ts